<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">Actualizar Servicio</h4>
        <button type="button" class="btn-close" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="form">
            <label for="nombre">Nombre</label>
            <input type="text" class="form-control" id="nombre" formControlName="nombre"
                [ngClass]="{'is-invalid': form.controls['nombre'].errors && form.controls['nombre'].touched}">
            <div class="invalid-feedback">
                Debe ingresar un valor en el campo.
            </div>
            <div class="mb-4" *ngIf="!form.controls['nombre'].errors || !form.controls['nombre'].touched">
            </div>
            <label for="precio_venta">Precio por defecto</label><label class="campo-opcional"> (Opcional)</label>
            <input type="text" class="form-control" id="precio_venta" formControlName="precio_venta"
                [ngClass]="{'is-invalid': form.controls['precio_venta'].errors && form.controls['precio_venta'].touched}"
                thousandSeparator="." mask="separator.0" [allowNegativeNumbers]="false">
            <div class="invalid-feedback">
                Debe ingresar un valor en el campo.
            </div>
            <div class="mb-4" *ngIf="!form.controls['precio_venta'].errors || !form.controls['precio_venta'].touched">
            </div>
            <label for="descripcion">Descripción</label><label class="campo-opcional"> (Opcional)</label>
            <textarea class="form-control" id="descripcion" rows="6" formControlName="descripcion"></textarea>
            <div class="mb-4" *ngIf="!form.controls['descripcion'].errors || !form.controls['descripcion'].touched">
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="guardar()">Guardar</button>
        <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cancelar</button>
    </div>
</div>